// Load Styles
import '../scss/main.scss';

// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true,
});


const questions = [
  {
    "question": "¿Qué actividad disfrutas más en tu tiempo libre?",
    "type": "radio",
    "answer1": "Practicar yoga o meditación",
    "answer1Total": "1",
    "answer2": "Organizar tus proyectos",
    "answer2Total": "2",
    "answer3": "Explorar tendencias en estilo y modas",
    "answer3Total": "3",
    "answer4": "Participar en actividades de voluntariado",
    "answer4Total": "4",
  },
  {
    "question": "¿Cómo te describen tus amigos?",
    "type": "checkbox",
    "answer1": "Aprendo para contribuir y fortalecer a mi comunidad.",
    "answer1Total": "2",
    "answer2": "Aprendo para encontrar equilibrio y paz interior.",
    "answer2Total": "3",
    "answer3": "Me interesa explorar y expresar mi creatividad.",
    "answer3Total": "1",
    "answer4": "Busco adquirir habilidades que me posicionen como líder.",
    "answer4Total": "4",

  },
  {
    "question": "¿Cómo empiezas tu día ideal?",
    "type": "radio",
    "answer1": "Probándome outfits frente al espejo. 💃",
    "answer1Total": "3",
    "answer2": "Tomando café con amigas y resolviendo el mundo.",
    "answer2Total": "4",
    "answer3": "Con una meditación o estiramientos suaves. 🧘‍♀️",
    "answer3Total": "1",
    "answer4": "Revisando mi agenda y planificando la jornada. 📅",
    "answer4Total": "2",
  },
  {
    "question": "¿Qué tipo de temas te gustan?",
    "type": "radio",
    "answer1": "Emprendimiento y liderazgo.",
    "answer1Total": "2",
    "answer2": "Empoderamiento femenino y sororidad.",
    "answer2Total": "4",
    "answer3": "Bienestar y mindfulness.",
    "answer3Total": "1",
    "answer4": "Estilo personal y automaquillaje.",
    "answer4Total": "3",
  },
  {
    "question": "Si abres tu Instagram, ¿qué ves más seguido?",
    "type": "radio",
    "answer1": "Noticias sobre igualdad, derechos y causas sociales",
    "answer1Total": "4",
    "answer2": "Reels de yoga, alimentación saludable y mindfulness.",
    "answer2Total": "1",
    "answer3": "Fashion inspo y tendencias de skincare.",
    "answer3Total": "3",
    "answer4": "Frases motivacionales y hacks para ser más productiva.",
    "answer4Total": "2",

  },
  {
    "question": "¿Cuál es tu enfoque hacia el aprendizaje?",
    "type": "checkbox",
    "answer1": "Aprendo para contribuir y fortalecer a mi comunidad.",
    "answer1Total": "4",
    "answer2": "Aprendo para encontrar equilibrio y paz interior.",
    "answer2Total": "1",
    "answer3": "Me interesa explorar y expresar mi creatividad.",
    "answer3Total": "3",
    "answer4": "Busco adquirir habilidades que me posicionen como líder.",
    "answer4Total": "2",

  },
  {
    "question": "¿Qué te hace seguir adelante en momentos difíciles?",
    "type": "radio",
    "answer1": "Mi deseo de expresarme y crear",
    "answer1Total": "3",
    "answer2": "El apoyo y bienestar de mi comunidad",
    "answer2Total": "4",
    "answer3": "Mis objetivos y aspiraciones profesionales",
    "answer3Total": "2",
    "answer4": "Mi conexión interna y prácticas espirituales",
    "answer4Total": "1",
  },
  {
    "question": "¿Qué representa el éxito para ti?",
    "type": "checkbox",
    "answer1": "Sentirme libre de expresarme como soy",
    "answer1Total": "3",
    "answer2": "Aportar a una causa y cambiar el mundo",
    "answer2Total": "4",
    "answer3": "Vivir en paz y armonía conmigo misma",
    "answer3Total": "1",
    "answer4": "Lograr mis metas y ver resultados",
    "answer4Total": "2",
  },
  {
    "question": "¿Qué rol juegas en un grupo de amigas?",
    "type": "radio",
    "answer1": "La que siempre tiene un plan y motiva a todas 📅",
    "answer1Total": "2",
    "answer2": "La que da los mejores consejos espirituales ✨",
    "answer2Total": "1",
    "answer3": "La que sabe de moda, maquillaje y tendencias 💅",
    "answer3Total": "3",
    "answer4": "La que trae temas profundos y abre debates interesantes 🎙️",
    "answer4Total": "4",
  },
  {
    "question": "¿Cómo manejas el estrés?",
    "type": "checkbox",
    "answer1": "Practicando técnicas de relajación y mindfulness",
    "answer1Total": "1",
    "answer2": "Dedicándome a actividades creativas que me distraigan",
    "answer2Total": "3",
    "answer3": "Enfrentando los problemas de frente y buscando soluciones",
    "answer3Total": "2",
    "answer4": "Conversando con amigos y buscando apoyo en la familia",
    "answer4Total": "4",
  },
  {
    "question": "¿Qué red social refleja mejor tu personalidad?",
    "type": "radio",
    "answer1": "Instagram, donde la estética y la imagen importan 📸",
    "answer1Total": "3",
    "answer2": "Pinterest, inspiración y misticismo por todas partes 🖼️",
    "answer2Total": "1",
    "answer3": "Twitter, lista para opinar y debatir con el mundo 🔥",
    "answer3Total": "4",
    "answer4": "LinkedIn, siempre buscando oportunidades y aprendiendo 📊",
    "answer4Total": "2",
  },
  {
    "question": "Si tu vida tuviera un mantra, ¿cuál sería?",
    "type": "radio",
    "answer1": '“De gota en gota se llena el océano.” 🌎',
    "answer1Total": "4",
    "answer2": '“Tu estilo es tu mejor carta de presentación.” 💃',
    "answer2Total": "3",
    "answer3": '“Sueña en grande, trabaja duro.” 🚀',
    "answer3Total": "2",
    "answer4": '“Fluir es la clave.” 🌊',
    "answer4Total": "1",
  },
  {
    "question": "¿Qué objeto no puede faltar en tu bolso?",
    "type": "checkbox",
    "answer1": "Una libreta para anotar ideas",
    "answer1Total": "2",
    "answer2": "Un cuarzo o amuleto de protección",
    "answer2Total": "1",
    "answer3": "Un labial que me haga sentir poderosa",
    "answer3Total": "3",
    "answer4": "Un libro que me haga reflexionar",
    "answer4Total": "4",
  },
  {
    "question": "Si tuvieras un superpoder...",
    "type": "radio",
    "answer1": "Cambiar de forma",
    "answer1Total": "3",
    "answer2": "Leer energías",
    "answer2Total": "1",
    "answer3": "Controlar el tiempo",
    "answer3Total": "4",
    "answer4": "Teletransportarme",
    "answer4Total": "2",
  },
  {
    "question": "Reto de 30 días, ¿cuál eliges?",
    "type": "checkbox",
    "answer1": "Looks diferentes",
    "answer1Total": "3",
    "answer2": "Rutinas de ejercicio",
    "answer2Total": "2",
    "answer3": "Meditación diaria",
    "answer3Total": "1",
    "answer4": "Lecturas variadas",
    "answer4Total": "4",
  },
]

const vistasExtras = [
  {
    "img_extra":"",
    "titulo": "¿Qué es Urania?",
    "bajada": "",
    "texto": "Urania es más que una plataforma, es un movimiento.\nAquí, mujeres como tú aprenden, exploran y crecen juntas.\nNuestras instructoras compartirán sus secretos contigo a través de clases prácticas, ejercicios guiados, consejos 1 a 1 sobre emprendimiento, bienestar, creatividad, autocuidado para empoderarte y evolucionar.",
    "fuente": "",
    "cta_texto": "Entendido",
  },
  {
    "img_extra":"images/img_extra_01.png",
    "titulo": "El 80% de las mujeres",
    "bajada": "que invierten en su aprendizaje sienten más confianza y plenitud.\n¿Lista para unirte a ellas? 💜🚀",
    "texto": "",
    "fuente": "Fuente: Learning & Growth Report, 2023",
    "cta_texto": "Continuar",
  },
  {
    "img_extra":"images/img_extra_02.png",
    "titulo": "",
    "bajada": "Ximena Abarca vio “Introducción a la conciencia feminista” el 05 de febrero de 2023",
    "texto": '“Excelente curso, escuchar a Nerea es pura motivación para seguir trabajando en la justicia social y la reconstrucción de espacios que como mujeres nos han dejado de lado y silenciado. Hoy tenemos la GRAN posibilidad y oportunidad de estar presentes, de sentirnos, amarnos, entre otras, desde la mirada violeta y la aplicabilidad colectiva de la sororidad.”',
    "fuente": "",
    "cta_texto": "Siguiente",
  },
  {
    "img_extra":"images/img_extra_03.gif",
    "titulo": "Con Urania, obtendrás:",
    "bajada": "",
    "texto": "",
    "fuente": "",
    "cta_texto": "Continuar",
  },
  {
    "img_extra":"images/img_extra_04.gif",
    "titulo": "Con tu suscripción accederás a:",
    "bajada": "",
    "texto": "• Nuevos contenidos cada mes.\n\n• Instructores certificadas de toda latinoamérica.\n\n• Un solo precio que puedes pagar mensual, trimestral o anualmente.",
    "fuente": "",
    "cta_texto": "Continuar",
  },
  {
    "img_extra":"",
    "titulo": "¿Cómo aprendes con Urania?",
    "bajada": "",
    "texto": "Aquí no solo aprendes, te descubres.\nEn Urania encontrarás cursos que despiertan tu intuición, potencian tu creatividad y te dan herramientas para alcanzar tus metas.\n🎓 Sin límites, sin reglas.\n🌍 Métodos probados para transformarte.\n💃 Descubrirás tu poder para usarlo a tu favor.\nDesde donde estés y a tu propio ritmo, ¡empieza a escribir tu nueva historia hoy mismo!",
    "fuente": "",
    "cta_texto": "Continuar",
  }
]

const resultados = [
  {
    "puntos": "4",
    "img":"images/lider.jpg",
    "arquetipo": "La Líder",
    "resultado": "Te mueven la transformación y el impacto social. Sabes que el cambio empieza desde dentro y quieres aprender para inspirar a otras.",
    "desc": "CREA LA REALIDAD QUE SUEÑAS YA"
  },
  {
    "puntos": "3",
    "img":"images/artista_nata.jpg",
    "arquetipo": "La Artista Nata",
    "resultado": "Para ti, la moda, el maquillaje y el arte no son superficiales, sino poderosos medios de autoexpresión. La belleza y la creatividad son tu esencia.",
    "desc": "DISEÑA TU MEJOR VERSIÓN AQUÍ"
  },
  {
    "puntos": "2",
    "img":"images/business_woman.jpg",
    "arquetipo": "Business Woman",
    "resultado": "Sabes que el éxito está en tus manos y buscas herramientas para construirlo. Te motiva aprender, emprender y hacer crecer tus proyectos.",
    "desc": "TOMA EL CONTROL DE TU DESTINO"
  },
  {
    "puntos": "1",
    "img":"images/hechicera.jpg",
    "arquetipo": "La Hechicera",
    "resultado": "Sientes que el universo tiene mensajes para ti y quieres aprender a leerlos. La astrología, el tarot y la meditación te ayudan a encontrar respuestas.",
    "desc": "DESPIERTA TU DON AHORA"
  }
]

let currentQuestion = 0;
let currentExtra = 0;
let currentResult = 0;

let completedViews = 0;

let score = [];
let currentAnswerScore;

const totalQuestions = questions.length;
const totalExtras = vistasExtras.length;

const questionEl = document.querySelector('.question');
const questionType = document.querySelectorAll('.btn-check');
const option1 = document.querySelector('.option1');
const option2 = document.querySelector('.option2');
const option3 = document.querySelector('.option3');
const option4 = document.querySelector('.option4');
const option1data = document.querySelector('.option1-data');
const option2data = document.querySelector('.option2-data');
const option3data = document.querySelector('.option3-data');
const option4data = document.querySelector('.option4-data');
const nextButton = document.querySelector('.next');

const extraTitulo = document.querySelector('.titulo-extra');
const extraBajada = document.querySelector('.bajada-extra');
const extraTexto = document.querySelector('.texto-extra');
const extraCTA = document.querySelector('.btn-extra');
const extraImg = document.querySelector('.extra-img');
const extraFuente = document.querySelector('.fuente-extra');

const resultadoArquetipo = document.querySelector('.arquetipo');
const resultadoResultado = document.querySelector('.resultado');

let progressBar = document.querySelector('.progress-bar');

const btnEmpezar = document.querySelector('.btn-begin');
const btnResultado = document.querySelector('.btn-resultados');
const btnSub = document.querySelector('.btn-sub');

const startcontainer = document.querySelector('.tc-tp-start');
const questcontainer = document.querySelector('.tc-tp-preguntas');
const questcontainerqs = document.querySelector('.tc-tp-preguntas-cont');
const extraContainer = document.querySelector('.tc-tp-extras');
const resultsContainer = document.querySelector('.tc-tp-resultados');
const subContainer = document.querySelector('.tc-tp-subscribir');
const graciasContainer = document.querySelector('.tc-tp-gracias');

let qCompletado = false;
let isMobile = false;

questcontainer.style.display = 'none';
extraContainer.style.display = 'none';
resultsContainer.style.display = 'none';
subContainer.style.display = 'none';
graciasContainer.style.display = 'none';

function generateQuestions (index) {
  const question = questions[index];
  const option1Total = questions[index].answer1Total;
  const option2Total = questions[index].answer2Total;
  const option3Total = questions[index].answer3Total;
  const option4Total = questions[index].answer4Total;

  questionEl.innerHTML = `${question.question}`

  for (var i=0; i < questionType.length; i++) {
    questionType[i].type = `${question.type}`;
  }

  option1data.setAttribute('data-total', `${option1Total}`);
  option2data.setAttribute('data-total', `${option2Total}`);
  option3data.setAttribute('data-total', `${option3Total}`);
  option4data.setAttribute('data-total', `${option4Total}`);

  option1.innerHTML = `${question.answer1}`
  option2.innerHTML = `${question.answer2}`
  option3.innerHTML = `${question.answer3}`
  option4.innerHTML = `${question.answer4}`

  completedViews++
}

function generateExtras (index) {
  const vistasExtra = vistasExtras[index];

  extraTitulo.innerHTML = vistasExtra.titulo;
  extraBajada.innerHTML = vistasExtra.bajada;
  extraTexto.innerHTML = vistasExtra.texto;
  extraCTA.innerHTML = vistasExtra.cta_texto;
  extraImg.src = vistasExtra.img_extra;
  extraFuente.innerHTML = vistasExtra.fuente;

  completedViews++
}

function generateResults (index) {

  const resultado = resultados[index];

  resultadoArquetipo.innerHTML = resultado.arquetipo;
  resultadoResultado.innerHTML = resultado.resultado;
  btnResultado.innerHTML = resultado.desc;
  resultsContainer.style.backgroundImage = "url('" + resultado.img + "')";
}

btnEmpezar.addEventListener('click', showQuestions);

function showQuestions() {
  generateQuestions(currentQuestion);

  startcontainer.style.display = 'none';
  questcontainer.style.display = 'block';
}

function loadNextQuestion() {
  const selectedOption = document.querySelectorAll('input:checked');

  for (var i=0; i < selectedOption.length; i++) {
    currentAnswerScore = Number(selectedOption[i].nextElementSibling.getAttribute('data-total'));
    selectedOption[i].checked = false;
  }

  score.push(currentAnswerScore);

  if(selectedOption.length === 0) {
    alert('No olvides elegir una opción.');
    return;
  }

  if(currentQuestion === totalQuestions - 1) {
    nextButton.textContent = 'Resultado';

    updateProgress();
    showResults();
    return;
  } else {
    switch (completedViews) {
      case 1:
        showVistaExtra();
        break;
      case 4:
        showVistaExtra();
        break;
      case 8:
        showVistaExtra();
        break;
      case 12:
        showVistaExtra();
        break;
      case 16:
        showVistaExtra();
        break;
      default:
        currentQuestion++;
        generateQuestions(currentQuestion);
        break;
    }
  }

  updateProgress();
}

function showVistaExtra() {
  questcontainer.style.display = 'block';
  questcontainerqs.style.display = 'none';
  extraContainer.style.display = 'block';
  resultsContainer.style.display = 'none';

  generateExtras(currentExtra);

  const extraCTA = document.querySelector('.btn-extra');
  const newExtraCTA = extraCTA.cloneNode(true);
  extraCTA.parentNode.replaceChild(newExtraCTA, extraCTA);

  if(currentExtra === totalExtras - 1) {
    newExtraCTA.addEventListener('click', showSub);
  } else {
    newExtraCTA.addEventListener('click', proceedWithQuiz);
  }

  updateProgress();
}

function proceedWithQuiz() {
  currentQuestion++
  currentExtra++;

  extraContainer.style.display = 'none';
  questcontainerqs.style.display = 'block';

  generateQuestions(currentQuestion);
}

function showResults() {
  const totalScore = score.reduce((a, b) => a + b, 0);
  const averageScore = Math.round(totalScore / score.length);
  console.log(totalScore)
  console.log(averageScore)

  currentResult = Math.min(Math.max(averageScore, 1), 4);

  currentResult = resultados.findIndex(resultado =>
    resultado.puntos === currentResult.toString()
  );

  if (currentResult === -1) currentResult = 0;

  questcontainer.style.display = 'none';
  extraContainer.style.display = 'none';
  resultsContainer.style.display = 'block';

  generateResults(currentResult);
}
function updateProgress() {
  const totalViews = (totalQuestions + totalExtras);

  const progress = (completedViews / totalViews) * 100;

  progressBar.innerText = Math.floor(progress) + "%";
  progressBar.setAttribute('aria-valuenow', Math.floor(progress));
  progressBar.style.width = Math.floor(progress) + "%";

}
function showSub() {
  resultsContainer.style.display = 'none';
  subContainer.style.display = 'block';
}
function showGracias() {
  subContainer.style.display = 'none';
  graciasContainer.style.display = 'block';
}
function initializeQuiz() {
  progressBar.value = 0;
}
initializeQuiz();

nextButton.addEventListener('click', loadNextQuestion);
btnResultado.addEventListener('click', showSub);


btnSub.addEventListener('click', validarSiMail);

function validarSiMail() {
  function valid(mailUser) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(mailUser);
  }
  const mailUser = document.querySelector("#tc-tp-sub").value;

  if (valid(mailUser) == true) {
    subsAPIInfo();
  } else {
    alert("Debe ingresar un correo electrónico válido.")
    return false;
  }
}

function detectMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    isMobile = true;
    return navigator.userAgent.match(toMatchItem);
  });
}

isMobile = detectMobile();

document.addEventListener("visibilitychange", () => {
  if (document.hidden) {
    if (isMobile == true) {
      sendAPIInfo();
    }
  }
});

// Envio de datos

window.addEventListener("beforeunload", function(){
  if(qCompletado == true) {
    console.log("autodestruir")
  } else {
    sendAPIInfo();
  }
});

function sendAPIInfo() {
  event.preventDefault();
  event.returnValue = true;

  console.log('saved');

  var fechaActual = new Date;
  const fechaFormato =  fechaActual.getFullYear() + "-" + ('0' + (fechaActual.getMonth()+1)).slice(-2) + "-" + ('0' + fechaActual.getDate()).slice(-2) + " " + fechaActual.toLocaleTimeString("es-ES");
  let preguntaActual;

  if(questionEl.innerText == "") {
    preguntaActual = "No se empezó";
  } else {
    preguntaActual = (currentQuestion + 1) + ". " + questionEl.innerText;
  }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const aMedias = JSON.stringify({
    "created_at": fechaFormato,
    "pregunta": preguntaActual,
    "source": "urania_quiz",
  });

  console.log(aMedias)

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: aMedias,
    redirect: "follow"
  };

  fetch("https://infoapi.multinetlabs.com/api/infoLp", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));

  var xhr = new XMLHttpRequest();
  var url = "https://infoapi.multinetlabs.com/api/infoLp";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
    }
  }
};

function subsAPIInfo() {
  event.preventDefault();
  event.returnValue = true;

  showGracias();

  var fechaActual = new Date;
  const fechaFormato =  fechaActual.getFullYear() + "-" + ('0' + (fechaActual.getMonth()+1)).slice(-2) + "-" + ('0' + fechaActual.getDate()).slice(-2) + " " + fechaActual.toLocaleTimeString("es-ES");
  const mailUser = document.querySelector("#tc-tp-sub").value;
  const resultadoActual = resultadoArquetipo.innerText;

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  qCompletado = true;

  console.log(qCompletado)

  const quizCompletado = JSON.stringify({
    "created_at": fechaFormato,
    "user_id": mailUser,
    "resultado": resultadoActual,
    "source": "urania_quiz",
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: quizCompletado,
    redirect: "follow"
  };

  fetch("https://infoapi.multinetlabs.com/api/infoLp", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));

  var xhr = new XMLHttpRequest();
  var url = "https://infoapi.multinetlabs.com/api/infoLp";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
    }
  }

}
